var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"position-absolute bottom-0 end-0 nav-link",domProps:{"textContent":_vm._s(_vm.deadline)}})
}
var staticRenderFns = []

export { render, staticRenderFns }